export const IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/svg+xml',
  'image/heif',
];

export const VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/quicktime',
  'video/webm',
  'video/x-m4v',
  'video/x-msvideo',
];

export const PDF_MIME_TYPE = 'application/pdf';

export const DOC_MIME_TYPE = 'application/msword';
